/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum BusinessStatus {
  blocked = 'blocked',
}

export enum VatNumberErrors {
  VatNumberBlockedAlert = 'PAGES.AUTH.ADD_BUSINESS_DETAILS.ERROR.VAT_NUMBER_BLOCKED',
  VatNumberBlockedTitleAlert = 'PAGES.AUTH.ADD_BUSINESS_DETAILS.ERROR.VAT_NUMBER_BLOCKED.TITLE',
  VatNumberNotValidAlert = 'PAGES.AUTH.ADD_BUSINESS_DETAILS.ERROR.VAT_NUMBER_NOT_VALID',
  VatNumberNotValidAlertOnVATIdCheck = 'PAGES.AUTH.ADD_BUSINESS_DETAILS.ERROR.VAT_NUMBER_NOT_VALID_ON_VAT_ID_CHECK',
  VatNumberNotValidTitleAlert = 'PAGES.AUTH.ADD_BUSINESS_DETAILS.ERROR.VAT_NUMBER_NOT_VALID.TITLE',
}
